import * as _ from 'lodash'
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SessionStorageService, FileService, CatalogService, LocalStorageService } from '../../../../common/modules/core/services';
import { ClassChild, SendEmail } from '../../../models';
import { BookingComponent } from '../BookingComponent';
// Services
import { BookingHolidayService } from '../../../services';
import { EmailService } from '../../../services';

@Component({
    selector: 'complete',
    template: require('./FinishComponent.html'),
    styles: [ require('./FinishComponent.sass') ]
})

export class FinishComponent extends BookingComponent implements OnInit {
    private booking: any;
    private user: any;
    private bookingDetail: any;
    private startDate: string;

    constructor(
        protected fileService: FileService,
        protected router: Router,
        protected bookingService: BookingHolidayService,
        protected emailService: EmailService,
        protected sessionStorageService: SessionStorageService,
        protected local: LocalStorageService,
        protected services: BookingHolidayService
    ) {
        super(router, services, sessionStorageService);
    }

    ngOnInit() {
        this.booking = this.getBooking();
        this.getBookingDetail(this.booking.id);
        if(this.booking.postedPeriods){
            this.startDate = this.booking.postedPeriods[0].start_date
        }
        this.user = this.sessionStorageService.getData('eca-user');
    }

    getBookingDetail(bookingId: any) {
        this.bookingDetail = {};
        let query = {
            id: bookingId,
            page: 1
        }
        this.bookingService.getBooking(query)
            .subscribe(
                bookingDetail => {
                    this.bookingDetail = bookingDetail.data[0]
                },
                error => {

                }
            )
    }

    finishBooking(){
        this.sessionStorageService.removeData('holidayBooking')
        this.router.navigate(['booking/students']);
    }
}


// WEBPACK FOOTER //
// ./src/holiday/parent/booking/6-finish/FinishComponent.ts